import React, { Component } from "react";
import PopUpForm from "../../../Generic/PopUpDialog/PopUpForm";
import { connect } from "react-redux";
import { API } from "aws-amplify";
import { setRefresh } from "../../../../actions/algoliaActions";
import { setAlgoliaLoaderState } from "../../../../actions/loaderActions";
import config from "../../../../config";

class CreateCurtainTapePopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationTypes: [
        {
          id: "name",
          label: "Curtain Tape Name",
          type: "text",
          tooltip: "Please Enter Curtain Tape Name",
          required: true,
          value: ""
        },
        {
          id: "description",
          label: "Description",
          type: "text",
          tooltip: "Please Enter Taper Description",
          value: ""
        },
        {
          id: "hookWidth",
          label: "Hook Width",
          type: "number",
          tooltip: "Please Enter Hook Width",
          value: 0
        },
        {
          id: "extraEnd",
          label: "Extra Ends",
          type: "number",
          tooltip: "Please Enter End Extra",
          value: 0
        },
        {
          id: "manufacturerId",
          label: "Manufacturer ID",
          type: "AlgoliaSelect",
          index: `${config.algolia.prefix}manufacturers_name_asc`,
          filters: "isDeleted:false",
          value: ""
        },
        {
          id: "associatedServices",
          label: "Associated Services",
          type: "multiSelect",
          index: `${config.algolia.prefix}products_services_fees_name_asc`,
          value: []
        },
        {
          id: "associatedRunners",
          label: "Associated Runners",
          type: "multiSelect",
          index: `${config.algolia.prefix}products_components_name_asc`,
          filter: " AND type:runner",
          value: []
        }
      ]
    };
  }

  handleCancelClick = () => {
    this.props.history.goBack();
  };

  APIMethod = async formData => {
    try {
      this.props.dispatch(setAlgoliaLoaderState(true));
      const body = {
        details: {
          name: formData.name,
          description: formData.description,
          hookWidth: formData.hookWidth,
          extraEnd: formData.extraEnd,
          associatedRunners: formData.associatedRunners,
          associatedServices: formData.associatedServices,
          manufacturerId: formData.manufacturerId
        }
      };
      await API.post("telishadeAPI", "/product/curtain/component/tape", {
        body
      });
      this.props.history.push(`/products/curtains/tape`);
      this.props.dispatch(setRefresh(true));
      this.props.dispatch(setAlgoliaLoaderState(false));
    } catch (e) {
      this.props.dispatch(setAlgoliaLoaderState(false));
      throw e;
    } finally {
      // Refresh any algolia components currently mounted 1 second after updating
      setTimeout(() => {
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setRefresh(true));
        this.props.dispatch(setRefresh(false));
      }, 0);
    }
  };

  render() {
    return (
      <PopUpForm
        fields={this.state.validationTypes}
        apiMethod={this.APIMethod}
        header="Add New Curtain Tape"
        button="Accept"
        buttoncolour="green"
        button2="Cancel"
        button2colour="red"
      />
    );
  }
}

export default connect()(CreateCurtainTapePopUp);
